import { Account } from "./../../screens/user-profile/client-data";
import { TranslateService } from "@ngx-translate/core";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { StatementComponent } from "src/app/screens/user-profile/statement/statement.component";
import { InvoicesModalComponent } from "../invoices-modal/invoices-modal.component";
import { ApiService } from "src/app/services/api.service";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-account-header",
  templateUrl: "./account-header.component.html",
  styleUrls: ["./account-header.component.scss"],
})
export class AccountHeaderComponent implements OnInit {
  @Input() selectedAccount;
  @Input() accList: any[];
  @Output() accChange = new EventEmitter<Account>();
  accObject: any;
  isDarkTheme: boolean;

  constructor(
    public translate: TranslateService,
    private dialog: MatDialog,
    private apiService: ApiService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.accList)
      this.accObject = this.accList.find(
        (x) => x.relationCode === this.selectedAccount
      );
  }

  get getColor() {
    switch (this.accObject.accountType) {
      //Basic
      case 0:
        return {
          background: this.isDarkTheme?"palegreen":"#28a745" ,
          color: this.isDarkTheme?"darkslategrey":"white",
        };
      //Margin
      case 1:
        return {
          background: "salmon",
          color: "black",
        };
      //MarginCustion
      case 2:
        return {
          background: "salmon",
          color: "black",
        };
      //Fund
      case 3:
        return {
          background: "cyan",
          color: "black",
        };
      //Other
      case 4:
        return {
          background: "aquamarine",
          color: "black",
        };
      //Qasser
      case 1001:
        return {
          background: "lightgoldenrodyellow",
          color: "black",
        };
      default:
        return {
          background: "lightgray",
          color: "black",
        };
    }
  }

  openStatement() {
    this.dialog.open(StatementComponent, {
      width: "700px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
      data: {
        inputUser: this.selectedAccount,
      },
    });
  }
  openInvoice() {
    this.dialog.open(InvoicesModalComponent, {
      width: "1000px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
      data: {
        inputUser: this.selectedAccount,
      },
    });
  }

  ngOnInit(): void {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;}

  changed() {
    this.accChange.next(this.selectedAccount);
  }

  isLoadingPdf: boolean = false;
  downloadPDF() {
    this.isLoadingPdf = true;
    let date = new Date().toISOString();
    this.apiService.fetchClientPortfolio(this.selectedAccount, date).subscribe(
      (res) => {
        this.isLoadingPdf = false;
        window.open(UrlConstants.backofficeUrl + res["fileURL"], "_blank");
      },
      (err) => {
        this.isLoadingPdf = false;
      }
    );
  }
}
